import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['proforma', 'contract'];

  ensureOnlyOneChecked(event) {
    if (event.target.id == 'invoice_proforma') {
      this.disableOtherOption(this.contractTarget);
    } else if (event.target.id == 'invoice_contract') {
      this.disableOtherOption(this.proformaTarget);
    }
  }

  disableOtherOption(optionElement) {
    const checkboxInput = optionElement.querySelector("input[type='checkbox']");
    checkboxInput.checked = false;
  }
}
